import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import { postRequest } from 'api';

export const postLoginData = createAsyncThunk('login/postLoginData', async ({params}, thunkApi) => {
        try{
            const {data} = await postRequest('/o/token/coach', params)
            console.log('data', data)
            if(data.access_token){
                localStorage.setItem('Authentication', JSON.stringify(data));
            }
            return data
        }
        catch (error){
            return thunkApi.rejectWithValue(error.response.status)
        }
})

export const handleChangePassword = createAsyncThunk('register/handleChangePassword', async (values, thunkApi) => {
    try{
        const result = await postRequest('/coach/password/forget', values)
        console.log(result)
        return result
    }
    catch (error){
        console.log(error)
        return thunkApi.rejectWithValue(error.response.data.message)
    }
})

let token = localStorage.getItem('Authentication')
    ? JSON.parse(localStorage.getItem('Authentication')).access_token : '';
let refresh_token = localStorage.getItem('Authentication')
    ? JSON.parse(localStorage.getItem('Authentication')).refresh_token : '';
let token_type = localStorage.getItem('Authentication')
    ? JSON.parse(localStorage.getItem('Authentication')).token_type : '';

const initialState = {
    token: '' || token,
    refreshToken: '' || refresh_token,
    tokenType: '' || token_type,
}

const loginSlice = createSlice({
    name: 'login',
    initialState: {
        ...initialState,
        response: '',
        status: {
            loadingState: false,
            errorLogin: false,
            wrongUserPass: false,
            loadingPasswordChange: false
        },
        passwordChangeMessage: false
    },
    reducers: {
        requestLogin: (state, action) => {
            return state
        },
        loginError: (state, action) => {
            return state
        },
        setStatus: (state, action) => {
            switch (action?.payload?.type){
                case 'errorLogin':
                    state.status.errorLogin = action.payload?.payload
                    break;
                case 'wrongUserPass':
                    state.status.wrongUserPass =action.payload?.payload
                    break;
                case 'changePasswordLoading':
                    state.status.loadingPasswordChange = action.payload?.payload
                    break;
                default:
                    console.log('not found',action)
            }
        },
        requestLogOut: (state, action) => {
            return {
                ...state,
                token: '',
                refreshToken: '',
                tokenType: ''
            };
        }
    },
    extraReducers(builder){
        builder
            .addCase(postLoginData.fulfilled, (state, action) => {
                console.log('state login',state)
                return {...state,
                    response: action.payload,
                    status: {...state.status, loadingState: false},
                    token: action.payload.access_token,
                    refreshToken: action.payload.refresh_token,
                    tokenType: action.payload.token_type
                }
            })
            .addCase(postLoginData.pending, (state) => {

                state.status.loadingState = true
            })
            .addCase(postLoginData.rejected, (state, action) => {
                state.status.loadingState = false
                if(action.payload === 400){
                    state.response = { error: '400 Error' }
                }
            });
        builder
            .addCase(handleChangePassword.fulfilled, (state, action) => {
                if(action.payload.status === 200){
                    state.passwordChangeMessage = action.payload.message
                    state.status.loadingPasswordChange = 'sentData'
                }
            })
            .addCase(handleChangePassword.pending, (state, action) => {
                state.status.loadingPasswordChange = true
            })
            .addCase(handleChangePassword.rejected, (state, action) => {
                state.status.loadingPasswordChange = 'error'
                state.passwordChangeMessage = action.payload
            })
    }
})

export const {requestLogin, loginError, setStatus, requestLogOut} = loginSlice.actions
export const selectResponse = state => state.login.response
export const selectLoginStatus = state => state.login.status
export const selectPasswordChangeMessage = state => state.login.passwordChangeMessage
export default loginSlice.reducer